export const AUTH_REGISTER_REQUEST = 'auth/register-request'
export const AUTH_REGISTER_SUCCESS = 'auth/register-success'
export const AUTH_REGISTER_FAILED = 'auth/register-failed'
